import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../hooks';
import { SimulcastTable } from '../../../elements';
import { schema } from './schema';
import { auctionTypesWithAll as auctionTypes, allAuctionType } from './../../../data';
import SelectionFilter from '../SelectionFilter/index';

const AuctionsHome = observer(() => {
// const AuctionsHome = observer(({onStatusChange, initialStatus}) => {
  const {
    UIStore: { setHeaderText, headerText },
    AuctionStore: { isLoading, loadAuctions, auctions: data, totalItems },
  } = useStores();
  
  const [auctionState, setAuctionState] = useState(allAuctionType);
  const [searchParams, setSearchParams] = useState([]);

  const onAuctionStateChanged = (option) => {
    setAuctionState(option);
    // onStatusChange(option);
    setHeaderText(option.text)
  }

  const onClearSearch = () => onAuctionStateChanged(allAuctionType);
  const onSearchTextChanged = (searchParams) => setSearchParams(searchParams);
  
  const {
    headerSchema,
    tableSettings: {
      getMethods,
      initialSortColumn,
      initialSortDirection,
      pageSelectTitle,
      searchFields,
    },
    bodySchema,
    debugging,
  } = schema;

  // FIXME: Sometimes, switching from pending to ALL auctions reloads the pending auctions. Need to look into.
  const state = auctionState.value === 'ALL' ? null : auctionState.value;
  // console.log('state', { state, searchParams, auctionState, headerText })
  const auction = { state, fn: loadAuctions, searchText: searchParams };
  const methods = getMethods(auction);
  const tableKey = `${auctionState.value}`;

  useEffect(() => {
    setHeaderText(allAuctionType.text)
  },[])

  if (!methods) return null;

  return (
    <SimulcastTable
      key={tableKey}
      bodySchema={bodySchema}
      debugging={debugging}
      headerSchema={headerSchema}
      initialMediaState={null}
      initialSortDirection={initialSortDirection}
      initialSortColumn={initialSortColumn}
      initialSearchParams={searchParams}
      isLoading={isLoading}
      methods={methods}
      pageSelectTitle={pageSelectTitle}
      searchFields={searchFields}
      onSearchTextChanged={onSearchTextChanged}
      onClearSearch={onClearSearch}
      rowData={data}
      totalItems={totalItems}
      exportButton={{
        visible: data.length > 0,
        fileName: `AuctionsReport`,
        sheetName: 'Auction List',
        showLocation: ['top'],
      }}
    >
      <SelectionFilter 
        initialValue={auctionState}
        options={auctionTypes}
        onChange={onAuctionStateChanged}
        title="Status"
      />
    </SimulcastTable>
  );
});

export default AuctionsHome;
